// DashboardButton.jsx
import React, { useEffect, useState } from 'react';
import { Button, Stack, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import DemoModal from './DemoModal';

export default function DashboardButton({
    stackSx,
    buttonSx,
    demoButtonSx,
    directionOverride,
    fullWidthOverride,
    loggedInOverride,
}) {
    const navigate = useNavigate();
    const isSmall = useMediaQuery('(max-width:960px)');
    const [loggedIn, setLoggedIn] = useState(Boolean(loggedInOverride));

    useEffect(() => {
        if (typeof loggedInOverride === 'boolean') {
            setLoggedIn(loggedInOverride);
            return;
        }

        fetch(API_URL + 'validate_session.php', {
            credentials: 'include',
        })
            .then(res => res.json())
            .then(data => setLoggedIn(Boolean(data.loggedIn)))
            .catch(console.error);
    }, [loggedInOverride]);

    const handleMain = () => {
        navigate(loggedIn ? '/list' : '/auth');
    };

    const direction = directionOverride || (isSmall ? 'column' : 'row');
    const isFullWidth = typeof fullWidthOverride === 'boolean' ? fullWidthOverride : isSmall;

    return (
        <Stack
            direction={direction}
            spacing={1}
            alignItems="center"
            sx={{ width: isFullWidth ? '100%' : 'auto', ...stackSx }}
        >
            <Button
                variant="outlined"
                onClick={handleMain}
                fullWidth={isFullWidth}
                sx={{
                    textTransform: 'none',
                    borderRadius: 2,
                    borderColor: '#4a90e2',
                    color: '#4a90e2',
                    px: 2,
                    py: 1,
                    ...buttonSx,
                }}
            >
                {loggedIn ? 'Dashboard' : 'Login'}
            </Button>

            <DemoModal buttonSx={demoButtonSx} fullWidthOverride={isFullWidth} />
        </Stack>
    );
}
